import { Auth } from "shared/@auth";

import React, { useEffect, useState } from "react";
import styles from "./index.module.css";

import { Section } from "shared/layout";

import AlertNotice from "shared/AlertNotice";
import { Danger } from "react-ikonate";

import { Form } from "shared/@forms/Form";
import TextInput from "shared/@forms/TextInput";
import EmailInput from "shared/@forms/EmailInput";

import Button, { ButtonPurpose } from "shared/Button";
import { useIBOInfo } from "Membership/LookupByIBO/useIBOInfo";

export default function TopicsAdd({ data, onSubmit }) {
  const [pinLevel, setPinLevel] = useState(0);

  const [contact, setContact] = useState({
    iboNumber: 0,
    wwgId: 0,
    firstName: "",
    lastName: "",
    email: "",
    pinLevel: 0,
  });
  const [isBusy, setIsBusy] = useState(false);

  // Use useIBOInfo to fetch IBO info
  const { iboInfo, isLoading, isError, error } = useIBOInfo(
    data?.wwgInfo?.iboNumber
  );

  useEffect(() => {
    if (data) {
      setPinLevel(data.wwgInfo.pinLevel);

      setContact({
        iboNumber: Number(data.wwgInfo.iboNumber),
        wwgId: Number(data.wwgInfo.wwgId),
        firstName: data.wwgInfo.firstName,
        lastName: data.wwgInfo.lastName,
        email: !data.wwgInfo.email ? "" : data.wwgInfo.email,
        type: data.wwgInfo.type,
      });
    }
  }, [data]);

  // Log IBO Info for debugging
  // useEffect(() => {
  //   if (iboInfo) {
  //     console.log("IBO Info:", JSON.stringify(iboInfo, null, 2));
  //   }
  //   if (isError) {
  //     console.error("Error fetching IBO Info:", error);
  //   }
  // }, [iboInfo, isError, error]);

  // Conditionally render based on hasDreamStream
  const hasDreamStream = iboInfo?.hasDreamStream;

  return (
    <Section className={styles.mb1}>
      <Form
        onSubmit={(e) => {
          setIsBusy(true);
          onSubmit(contact);
        }}
      >
        <header>
          <h3>
            {contact.firstName} {contact.lastName} ({contact.type})
          </h3>
        </header>
        <div>
          {!hasDreamStream ? (
            <AlertNotice icon={<Danger />} title="Topics Not Enabled">
              <div>
                {contact.firstName} {contact.lastName} does not have access to
                Topics. To add a Topics account, a Topics subscription is
                required.
              </div>
            </AlertNotice>
          ) : (
            <>
              <AlertNotice icon={<Danger />} title="No Topics Account Found">
                <div className={styles.mb1}>
                  {contact.firstName} {contact.lastName} does not have a Topics
                  account. To add, you will need to provide a name and email
                  address. The email address must be unique.
                </div>
              </AlertNotice>
              <div className={styles.splitGroup}>
                <div className={styles.inputGroup}>
                  <label htmlFor="topicsFirstName">First Name</label>
                  <TextInput
                    id="topicsFirstName"
                    required={true}
                    value={contact.firstName}
                    disabled={isBusy}
                    onChange={(e) => {
                      setContact({
                        ...contact,
                        firstName: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className={styles.inputGroup}>
                  <label htmlFor="topicsLastName">Last Name</label>
                  <TextInput
                    id="topicsLastName"
                    required={true}
                    value={contact.lastName}
                    disabled={isBusy}
                    onChange={(e) => {
                      setContact({
                        ...contact,
                        lastName: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div>
                <div className={styles.inputGroup}>
                  <label htmlFor="topicsEmail">Email</label>
                  <EmailInput
                    id="topicsEmail"
                    required={true}
                    value={contact.email}
                    disabled={isBusy}
                    onChange={(e) => {
                      setContact({
                        ...contact,
                        email: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={styles.actions}>
                <Button
                  purpose={ButtonPurpose.save}
                  className={isBusy ? styles.hidden : ""}
                >
                  Add
                </Button>
              </div>
            </>
          )}
        </div>
      </Form>
    </Section>
  );
}
